/** Grymwyrd локализация на русский для функции Play / VTT. */
export const playRu = {
  // CampaignList
  'play.campaigns.heading': 'Мои сюжеты',
  'play.campaigns.signIn': 'Войти',
  'play.campaigns.signInToSee': 'чтобы увидеть присоединённые сюжеты.',
  'play.campaigns.fallbackNotice': 'Показаны примеры сюжетов — ваш реестр не загрузился.',
  'play.campaigns.loading': 'Вспоминаем ваши саги…',
  'play.campaigns.empty': 'Вы ещё не присоединились ни к одному сюжету.',
  'play.campaigns.assignedCharacter': 'Назначенный персонаж',
  'play.campaigns.unassigned': 'Не назначен',
  'play.campaigns.noCharactersYet': 'Персонажей еще нет',
  'play.campaigns.enterCampaign': 'Войти в сюжет',

  // CampaignPage — VTT prototype
  'play.vtt.theTable': 'Стол',
  'play.vtt.launch': 'Запустить VTT',
  'play.vtt.iframeTitle': 'Grymwyrd VTT — сюжет {campaignId}',
  'play.vtt.veilHeadline': 'Завеса между столом и сказаньем тонка в этом месте.',
  'play.vtt.prototypeIntro':
    'Настоящий виртуальный стол — дело будущего. Интерактивный прототип встроится в этот фрейм — нажми',
  'play.vtt.prototypeOutro': 'чтобы подготовить контейнер.',

  // CampaignPage — encyclopedia sidebar
  'play.codex.heading': 'Кодекс поиска',
  'play.codex.searchPlaceholder': 'Ищи чудовище, заклятие, правило…',
  'play.codex.searchAriaLabel': 'Поиск в энциклопедии',
  'play.codex.searching': 'Гадаем…',
  'play.codex.noResults': 'Ничего не найдено для «{q}».',
  'play.codex.hint': 'Введи минимум два символа, чтобы искать в живой энциклопедии, не покидая стол.',

  // CampaignPage — detail
  'play.campaign.fallbackTitle': 'Сюжет',
  'play.campaign.fallbackDescription':
    'Детали сюжета не загрузились — ты всё ещё можешь подготовить своего персонажа ниже.',
  'play.campaign.seoTitle': 'Сюжет',
  'play.campaign.noneSpecified': 'Сюжет не указан.',
  'play.campaign.seoTitleNamed': '{title} — Игра',
  'play.campaign.seoTitleDefault': 'Сюжет — Игра',
  'play.campaign.backToLobby': 'Вернуться в лобби',
  'play.campaign.gm': 'Мастер {gm}',
  'play.campaign.playersCount': '{count} игроков',

  // CharacterSheet
  'play.sheet.savedToCodex': 'Сохранено в вашем кодексе.',
  'play.sheet.savedLocally': 'Сохранено локально (сервер недоступен).',
  'play.sheet.saveError': 'Не удалось сохранить вашего персонажа — хранилище недоступно.',
  'play.sheet.loading': 'Разворачиваем лист…',
  'play.sheet.heading': 'Лист персонажа',
  'play.sheet.avatarAlt': 'Аватар персонажа {name}',
  'play.sheet.unclaimedHero': 'Никому не принадлежащий герой',
  'play.sheet.abilityCheck': 'Проверка {ability} ({formula}):',
  'play.sheet.name': 'Имя',
  'play.sheet.namePlaceholder': 'Безымянный странник',
  'play.sheet.level': 'Уровень',
  'play.sheet.speciesLabel': 'Раса / Вид',
  'play.sheet.loadingOption': 'Загрузка…',
  'play.sheet.selectSpecies': 'Выбери расу',
  'play.sheet.classLabel': 'Класс',
  'play.sheet.selectClass': 'Выбери класс',
  'play.sheet.abilityScores': 'Показатели способностей',
  'play.sheet.abilityScoresHint': '(нажми на модификатор, чтобы бросить)',
  'play.sheet.abilityScoreAria': 'Показатель {ability}',
  'play.sheet.rollCheckAria': 'Бросить проверку {ability}',
  'play.sheet.hp': 'ОЖ',
  'play.sheet.maxHp': 'Макс. ОЖ',
  'play.sheet.ac': 'КД',
  'play.sheet.backstory': 'История персонажа',
  'play.sheet.backstoryPlaceholder': 'Какая тьма привела эту душу к столу?',
  'play.sheet.canonCandidate': 'Кандидат в канон',
  'play.sheet.canonCandidateHint': 'Добавь этого персонажа в список кандидатов на включение в живой канон Grymwyrd.',
  'play.sheet.saving': 'Сохраняем…',
  'play.sheet.saveCharacter': 'Сохранить персонажа',

  // CreateGameModal
  'play.create.errorNoName': 'Дай столу имя.',
  'play.create.errorNoSystem': 'Выбери систему.',
  'play.create.you': 'Ты',
  'play.create.errorCreate': 'Ритуал не сработал — стол не создан. Попробуй позже.',
  'play.create.modalTitle': 'Собрать стол',
  'play.create.successCopy': 'Стол готов. Поделись этой ссылкой приглашения, чтобы созвать игроков.',
  'play.create.copyInviteAria': 'Копировать ссылку приглашения',
  'play.create.copied': 'Скопировано',
  'play.create.copy': 'Копировать',
  'play.create.done': 'Готово',
  'play.create.tableName': 'Имя стола',
  'play.create.tableNamePlaceholder': 'например Склеп печали',
  'play.create.quickStart': 'Быстрый старт',
  'play.create.quickStartAria': 'Пресеты быстрого старта',
  'play.create.customPreset': 'Свой вариант',
  'play.create.customPresetDesc': 'Начать с нуля',
  'play.create.gameSystem': 'Система правил',
  'play.create.loadingSystems': 'Загружаем системы…',
  'play.create.systemFromPreset': '{system} (из пресета)',
  'play.create.systemDefault': 'Grymwyrd Cataclysm (по умолчанию)',
  'play.create.tags': 'Теги',
  'play.create.tagsUpTo': '(до {count})',
  'play.create.removeTagAria': 'Удалить тег {tag}',
  'play.create.tagLimitReached': 'Лимит тегов достигнут',
  'play.create.tagPlaceholder': 'ужас, вспомогательная сессия…',
  'play.create.maxPlayers': 'Максимум игроков:',
  'play.create.cancel': 'Отмена',
  'play.create.convening': 'Собираем…',
  'play.create.createTable': 'Создать стол',

  // JoinPage
  'play.join.finding': 'Ищем стол…',
  'play.join.expiredHeading': 'Это приглашение истекло',
  'play.join.expiredBody': 'Коды истекают в целях безопасности. Попроси у хоста новый.',
  'play.join.browseLiveTables': 'Просмотреть активные столы',
  'play.join.errorHeading': 'Не удалось добраться до стола',
  'play.join.errorBody': 'Что-то пошло не так при поиске приглашения. Проверь соединение и попробуй ещё раз.',
  'play.join.tryAgain': 'Попробовать снова',
  'play.join.defaultTableTitle': 'Стол Grymwyrd',
  'play.join.invited': 'Ты приглашён присесть за стол.',
  'play.join.signInToSeat': 'Войди, чтобы занять место',
  'play.join.createAccount': 'Новенький? Создай бесплатный аккаунт',
  'play.join.opensAfterSignIn': 'Стол откроется после входа.',

  // PlayLobbyPage
  'play.lobby.seoTitle': 'Игра — Виртуальный стол',
  'play.lobby.seoDescription':
    'Найди стол, присоединись к живой сессии и создай свою легенду на виртуальном столе Grymwyrd.',
  'play.lobby.eyebrow': 'Виртуальный стол',
  'play.lobby.title': 'Игра',
  'play.lobby.subtitle':
    'Собери ковен. Бросай кости. Присядь за стол, где каждое решение отзывается в живом канон Grymwyrd.',
  'play.lobby.createGame': 'Создать игру',
  'play.lobby.playNow': 'Играй сейчас — аккаунт не нужен',
  'play.lobby.signInToHost': 'Войди, чтобы провести свой стол',

  // SessionListLive
  'play.live.heading': 'Сейчас в сети',
  'play.live.empty': 'Нет активных столов в этот час. Завеса тиха — начни свой.',
  'play.live.badge': 'В сети',
  'play.live.unknownSystem': 'Неизвестная система',
  'play.live.gmSuffix': ' · Мастер {gm}',
  'play.live.players': 'игроков',

  // TableList — empty board
  'play.tables.emptyHeading': 'Открытых столов еще нет',
  'play.tables.emptyBody':
    'Доска молчит. Будь первым, кто придвинет стул — попробуй гостевой стол, аккаунт не требуется.',
  'play.tables.tryGuestTable': 'Попробовать гостевой стол',
  'play.tables.orUse': 'Или используй',
  'play.tables.createGame': 'Создать игру',
  'play.tables.aboveToHost': 'выше, чтобы провести свой.',

  // TableList — waitlist
  'play.waitlist.joinError': 'Не удалось встать в очередь — попробуй ещё раз.',
  'play.waitlist.leaveError': 'Не удалось выйти из очереди — попробуй ещё раз.',
  'play.waitlist.join': 'Встать в очередь',
  'play.waitlist.leaving': 'Выходим…',
  'play.waitlist.leave': 'Выйти из очереди',
  'play.waitlist.joining': 'Встаём…',

  // TableList — board
  'play.tables.heading': 'Открытые столы',
  'play.tables.openSeatOnly': 'Только свободные места',
  'play.tables.systemFilterPlaceholder': 'Система…',
  'play.tables.systemFilterAria': 'Фильтровать по системе',
  'play.tables.tagsFilterPlaceholder': 'Теги (через запятую)…',
  'play.tables.tagsFilterAria': 'Фильтровать по тегам',
  'play.tables.fetchError': 'Не удалось добраться до доски — лобби временно недоступно.',
  'play.tables.loading': 'Собираем столы…',
  'play.tables.untitledTable': 'Безымянный стол',
  'play.tables.full': 'Полностью занято',
  'play.tables.seatedCount': 'За столом {count}',
  'play.tables.viewTable': 'Просмотреть стол',

  // ── Live chat (P-E) — per-recipient translation (Option A) ────────────────
  'chat.heading': 'Чат стола',
  'chat.empty': 'Сообщений нет. Скажи что-нибудь столу.',
  'chat.inputPlaceholder': 'Написать столу…',
  'chat.inputAria': 'Сообщение в чат',
  'chat.send': 'Отправить',
  'chat.translatedFrom': 'Переведено с {lang}',
  'chat.original': 'Оригинал',
  'chat.showOriginal': 'Показать оригинал',
  'chat.showTranslation': 'Показать перевод',
  'chat.showOriginalsAll': 'Показать оригиналы',
  'chat.showTranslationsAll': 'Показать переводы',
}
